<template>
  <div class="modal-box">
    <transition name="fade">
      <setting-modal v-if="settingModal" />
    </transition>
    <transition name="fade">
      <QAmodal v-if="QAmodal" />
    </transition>
    <transition name="fade">
      <about-modal v-if="aboutModal" />
    </transition>
  </div>
</template>
<script>
import aboutModal from './aboutModal';
import QAmodal from './QAmodal';
import settingModal from './settingModal';
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState('modal', ['QAmodal', 'aboutModal', 'settingModal'])
  },
  components:{ aboutModal,QAmodal,settingModal }
};
</script>
<style lang="scss">

//For custom modal (QA modal / About modal)
.custom-modal {
  position: fixed; /* Stay in place */
  z-index: 1000; /* Sit on top */
  padding-top: 50px;
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.6); /* Black w/ opacity */
  .modal-content {
    max-height: 70vh;
    box-shadow: 5px 5px rgba(50, 50, 50, 0.8);
    position: relative;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
    background-color: rgba(252, 255, 253, 0.9);
    margin: auto;
    padding-top: 40px;
    padding-left: 20px;
    padding-right: 20px;
    border: 1px solid #888;
    border-radius: 10px;
    text-align: center;
    & > h1 {
      opacity: 0.6;
      position: absolute;
      font-weight: bold;
      top: 12px;
      left: 8px;
      border-bottom: 10px solid rgba(244, 133, 133, 0.3);
      padding-bottom: 2px;
      font-size: 18px;
      transform: rotate(-10deg);
    }
    & > .close {
      font-size: 24px;
      padding: 5px;
      border-radius: 10px;
      position: absolute;
      font-weight: bold;
      top: 10px;
      right: 10px;
      cursor: pointer;
      user-select: none;
    }
    & > .close:hover {
      background-color: black;
      color: white;
    }
    & > .content {
      height: 100%;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      margin: 20px 10px 10px 10px;
      text-align: left;

      .box {
        margin: 20px;
        padding: 20px auto;
        h2 {
          font-weight: bold;
        }
      }
      ul {
        margin-left: 20px;
        li {
          list-style: circle;
          margin: 10px 0px;
        }
      }
      .message-flex {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
      }
    }
  }
}
</style>
